import { sensorConstants } from "../_constants";

export function sensordata(state = {}, action) {
  switch (action.type) {
  case sensorConstants.SENSOR_DATA:
    return {
      ...state,
      type: "sensor_data",
      sensorDataList: action.list
    };
  case sensorConstants.SENSOR_ID:
    return {
      ...state,
      id: action.id
    };
  default:
    return state;
  }
}



// WEBPACK FOOTER //
// ./src/_reducers/sensordata.reducer.js